export const en = {
    'and-more-links': 'And {moreLinksCount} more',
    'filter-by-banner': 'Show logs for ad №{banner}',
    'filter-by-cid': 'Show logs for campaign №{cid}',
    'filter-by-group': 'Show logs for group №{group}',
    'open-banner': 'Go to ad №{banner}',
    'open-campaign': 'Go to campaign №{cid}',
    'open-group': 'Go to group №{group}'
};
